import React, { useEffect, useRef } from 'react';
import './Losepopup.css';
import gsap from 'gsap';
import { useNavigate } from 'react-router-dom';
import rockBg from '../../asserts/rockbg.png';
import coinImg from '../../asserts/coin.png';
import Btn3 from '../common/Btn3';
import Btn4 from '../common/Btn4';
import { useMusic } from './MusicContext';

const LosePopup = ({ onReplay }) => {
  const scrollRef  = useRef();
  const contentRef = useRef();
  const coinRef    = useRef();
  const { playResultMusic, stopResultMusic } = useMusic();
  const navigate = useNavigate();

  useEffect(() => {
    playResultMusic('lose');

    gsap.set(scrollRef.current, {
      rotation: 60, rotationX: -40, opacity: 0,
      transformOrigin: 'center center', transformPerspective: 1400,
      x: 100, y: 820, scale: 0.8,
    });
    const tl = gsap.timeline();
    tl.to(scrollRef.current, {
      rotation: 0, rotationX: 0, opacity: 1, x: 0, y: 0, scale: 1,
      duration: 1.3, ease: 'power3.out',
    })
    .fromTo(contentRef.current.querySelectorAll('.popup-animate'),
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.6, stagger: 0.12, ease: 'power2.out' }, '-=0.4'
    )
    .to(coinRef.current, {
      y: -14, duration: 1.2, ease: 'sine.inOut', yoyo: true, repeat: -1,
    }, '+=0.2');

    return () => stopResultMusic();
  }, []);

  const animateClose = (cb) => {
    if (!cb) return;
    stopResultMusic();
    const tl = gsap.timeline({ onComplete: cb });
    tl.to(contentRef.current.querySelectorAll('.popup-animate'), {
      opacity: 0, y: 20, duration: 0.25, stagger: 0.06, ease: 'power2.in',
    }).to(scrollRef.current, {
      rotation: -20, rotationX: 40, opacity: 0, x: -200, y: 120, scale: 0.8,
      duration: 1, ease: 'power3.in',
    }, '-=0.1');
  };

  const handleLevels = () => animateClose(() => navigate('/levels'));
  const handleReplay = () => animateClose(onReplay);

  return (
    <div className="popup-overlay">
      <div className="popup-scroll" ref={scrollRef} style={{ backgroundImage: `url(${rockBg})` }}>
        <div className="popup-innne" ref={contentRef}>
          <h2 className="popup-title popup-animate">Trial Failed</h2>
          <p className="popup-subtitle popup-animate">Memory fails: the fragment stays hidden.</p>
          <div className="lose-coin popup-animate" ref={coinRef}>
            <img src={coinImg} alt="Lost Coin" />
            <span className="lose-coin-label">Lose Coin</span>
          </div>
          <div className="popup-row-buttons popup-animate">
            <Btn3 btnt="Levels" onClick={handleLevels} />
            <Btn4 label="Replay" onClick={handleReplay} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LosePopup;